import {
  BoardCommonControllerService,
  BoardVo,
} from '@/__generated__/CommonApi';
import Icon1 from '@/assets/img/advocacy-for-children/icon_school_membership1@2x.png';
import Icon2 from '@/assets/img/advocacy-for-children/icon_school_membership2@2x.png';
import Obj1 from '@/assets/img/advocacy-for-children/school_obj1@2x.png';
import Obj2 from '@/assets/img/advocacy-for-children/school_obj2@2x.png';
import Obj3 from '@/assets/img/advocacy-for-children/school_obj3@2x.png';
import Obj4 from '@/assets/img/advocacy-for-children/school_obj4@2x.png';
import Obj5 from '@/assets/img/advocacy-for-children/school_obj5@2x.png';
import Obj6 from '@/assets/img/advocacy-for-children/school_obj6@2x.png';
import Obj7 from '@/assets/img/advocacy-for-children/school_obj7@2x.png';
import Obj8 from '@/assets/img/advocacy-for-children/school_obj8@2x.png';
import Obj9 from '@/assets/img/advocacy-for-children/school_obj9@2x.png';
import Processor1 from '@/assets/img/advocacy-for-children/school_processor1@2x.png';
import Processor2 from '@/assets/img/advocacy-for-children/school_processor2@2x.png';
import Processor3 from '@/assets/img/advocacy-for-children/school_processor3@2x.png';
import Processor4 from '@/assets/img/advocacy-for-children/school_processor4@2x.png';
import Processor5 from '@/assets/img/advocacy-for-children/school_processor5@2x.png';
import Processor6 from '@/assets/img/advocacy-for-children/school_processor6@2x.png';
import Arrow from '@/assets/img/icons/arrow_right_sky@2x.png';
import Quotes from '@/assets/img/icons/ico_quotes@2x.png';
import { CampaignData } from '@/components/Card/CampaignCard';
import RelativeBoardCard from '@/components/Card/RelativeBoardCard';
import ContactUs from '@/components/ContactUs';
import Container from '@/components/Container';
import { ObjList } from '@/components/Css/PublicPrivatePartnership';
import Image from '@/components/Image';
import LinkSafe from '@/components/LinkSafe';
import MultiAccordion, {
  MultiAccordionItem,
} from '@/components/MultiAccordion';
import PageComponent from '@/components/PageComponent';
import Section, { SectionNews } from '@/components/Section';
import SectionHeader from '@/components/SectionHeader';
import SwiperBasic from '@/components/Swiper/SwiperBasic';
import { Tit } from '@/components/Titles';
import YoutubeSingle from '@/components/YoutubeSingle';
import { breakpoint } from '@/helpers/BreakpointHelper';
import LayoutWithTitle from '@/layouts/LayoutWithTitle';
import { PublicPrivateTab } from '@/page-blocks/advocacy-for-children/public-private-partnership';
import { PageProps } from 'gatsby';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';

const schoolData = [
  {
    id: 0,
    img: Obj1,
    no: `01`,
    tit: `아동권리교육`,
  },
  {
    id: 1,
    img: Obj2,
    no: `02`,
    tit: `학교 운영 체계 수립`,
  },
  {
    id: 2,
    img: Obj3,
    no: `03`,
    tit: `상호존중`,
  },
  {
    id: 3,
    img: Obj4,
    no: `04`,
    tit: `안전`,
  },
  {
    id: 4,
    img: Obj5,
    no: `05`,
    tit: `발달 지원`,
  },
  {
    id: 5,
    img: Obj6,
    no: `06`,
    tit: `비차별`,
  },
  {
    id: 6,
    img: Obj7,
    no: `07`,
    tit: `참여중심의 교육활동`,
  },
  {
    id: 7,
    img: Obj8,
    no: `08`,
    tit: `참여`,
  },
  {
    id: 8,
    img: Obj9,
    no: `09`,
    tit: `사회참여활동`,
  },
];
const accordionData = [
  {
    id: 0,
    label: `참여`,
    data: [
      {
        dec: `<strong>대상: </strong>전국 초, 중, 고등학교`,
      },
      {
        dec: `<strong>등록방법: </strong>유니세프 아동친화사회팀 (02-724-8565 / <strong style=" color: #1cabe2;"><LinkSafe to="mailto:cfs@unicef.or.kr" className="Link-item"> cfs@unicef.or.kr</LinkSafe></strong>)`,
      },
    ],
  },
  {
    id: 1,
    label: `조성`,
    data: [
      {
        dec: `학교는 아동친화학교 구성요소를 갖추기 위한 계획을 수립·이행·모니터링합니다.`,
        processor: [
          {
            img: Processor1,
            tit: `아동권리교육`,
          },
          {
            img: Processor2,
            tit: `운영단 구성`,
          },
          {
            img: Processor3,
            tit: `권리 실태 조사`,
          },
          {
            img: Processor4,
            tit: `조성 계획 수립`,
          },
          {
            img: Processor5,
            tit: `계획 이행`,
          },
          {
            img: Processor6,
            tit: `모니터링`,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    label: `멤버십 가입 심사`,
    data: [
      {
        dec: `각 학교는 아동친화학교 운영 결과에 대한 자료를 제출합니다.`,
      },
      {
        dec: `유니세프는 학교 활동 및 진전 사항을 살펴보고, 학교에서 제출한 자료를 종합적으로 검토해 「아동친화학교 멤버십 가입」 자격 요건을 충족했는지 여부를 확인합니다.`,
      },
    ],
  },
  {
    id: 3,
    label: `인증`,
    data: [
      {
        dec: `멤버십 가입 심사 결과 「아동친화학교 멤버십 가입」 자격 요건을 충족한 학교는 멤버십을 가지게 됨으로써 유니세프아동친화학교로 인증됩니다.`,
      },
    ],
  },
];

const contactData = [
  {
    id: 1,
    tit: `문의`,
    costumer: `아동친화사회팀`,
    tel: `02-724-8565`,
    email: `cfs@unicef.or.kr`,
  },
];

const NavigationButton = styled.div`
  padding: 24px;
  cursor: pointer;
  position: relative;
`;
const AccordionBody = styled.div`
  padding: 24px;
  font-size: 16px;
  color: #2d2926;
  ${breakpoint(`mobile`)} {
    font-size: 14px;
    padding: 16px 0;
  }
`;
const ProcessorList = styled.ul`
  width: 100%;
  margin: 0 auto;
  margin-top: 12px;
  margin-bottom: 12px;
  max-width: 916px;
  position: relative;
  align-items: stretch;

  &:before,
  &::after {
    content: '';
    display: block;
    width: 85%;
    height: 1px;
    border-top: 1px dashed #1cabe2;
    position: absolute;
    top: 37px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: -1;
  }
  &::after {
    display: none;
  }

  & > li {
    width: 16.66%;
    text-align: center;
    position: relative;

    &::before {
      content: '';
      display: block;
      width: 7px;
      height: 13px;
      background: url(${Arrow}) center no-repeat;
      background-size: cover;
      position: absolute;
      top: 31px;
      right: -3px;
    }

    &:last-child {
      &:before {
        display: none;
      }
    }
    ${Image} {
      max-width: 75px;
      display: inline-block;
    }
    .dec {
      margin-top: 12px;
      display: inline-block;
      color: #1cabe2;
      white-space: nowrap;
    }
  }
  ${breakpoint(`tablet`)} {
    margin: 16px -12px;
    margin-left: -32px;
    width: auto;

    &::before,
    &::after {
      width: 70%;
    }
    &::after {
      display: block;
      top: 184px;
    }

    & > li {
      width: 33.33%;
      text-align: center;
      position: relative;
      margin-bottom: 28px;

      &:nth-child(3) {
        &:before {
          display: none;
        }
      }
    }
  }
  ${breakpoint(`mobile`)} {
    &::after {
      top: 180px;
    }
  }
`;
const SectionSchool = styled(Section)`
  padding-top: 0 !important;
  ${ObjList} {
    gap: 64px 0;
    & > li {
      width: 33.33%;
      margin-bottom: 0;
      .dec-wrap {
        margin-top: 24px;
        .no {
          line-height: 1;
          margin-bottom: 6px;
        }
      }
    }
    ${breakpoint(`mobile`)} {
      gap: 44px 0;
      & > li {
        width: 50%;
        .dec-wrap {
          margin-top: 20px;
        }
      }
    }
  }
`;
const SectionMembership = styled(Section)`
  ${breakpoint(`mobile`)} {
    ${SectionHeader} {
      padding-bottom: 48px;
      .header-dec {
        margin-top: 20px;
      }
    }
  }
  .section-body {
    display: flex;
    gap: 20px;

    ${breakpoint(`mobile`)} {
      flex-direction: column;
    }

    .box {
      border: 2px solid #1cabe2;
      border-radius: 30px;
      background: #fff;
      padding: 30px 20px;
      box-shadow: 2px 2px 20px 2px rgba(0, 0, 0, 0.1);

      .school-tit {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        border-radius: 10px;
        font-size: 20px;
        font-weight: 700;
        color: #fff;
        background: #1cabe2;

        &::before {
          content: '';
          display: block;
          margin-right: 10px;
        }
        ${breakpoint(`mobile`)} {
          font-size: 16px;
          height: 40px;

          &::before {
            margin-right: 6px;
          }
        }
      }
      .school-stages {
        display: flex;
        gap: 20px;
        margin: 10px 0 14px;

        .stage-list {
          flex: 1;
          height: 104px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          padding: 0 10px;
          border-radius: 10px;
          background: rgba(28, 171, 226, 0.1);
          text-align: center;

          .stage-tit {
            color: #1cabe2;
            font-weight: 700;
          }
          p {
            color: #666;
          }
        }
        ${breakpoint(`mobile`)} {
          gap: 10px;
          margin: 10px 0;

          .stage-list {
            height: auto;
            padding: 10px;
            line-height: 1.57;
          }
        }
      }
      .school-desc {
        background: #f6f6f6;
        border-radius: 10px;
        padding: 20px;
        text-align: center;
        line-height: 1.875;
        ${breakpoint(`mobile`)} {
          padding: 10px 20px;
          line-height: 2;
        }
      }

      &.pre-school {
        flex-basis: 620px;

        .school-tit {
          &::before {
            width: 26px;
            height: 20px;
            background: url(${Icon1}) no-repeat 0 0 / contain;
          }
        }
      }
      &.unicef-school {
        border-color: #374ea2;
        flex-basis: 480px;

        .school-tit {
          background: #374ea2;
          &::before {
            width: 20px;
            height: 24px;
            background: url(${Icon2}) no-repeat 0 0 / contain;
          }
        }
        .stage-list {
          background: rgba(55, 78, 162, 0.1);
          .stage-tit {
            color: #374ea2;
          }
        }
      }

      ${breakpoint(`mobile`)} {
        padding: 10px;
        border-radius: 20px;
        &.pre-school {
          flex-basis: 100%;
          .school-tit {
            &::before {
              width: 21px;
              height: 16px;
            }
          }
        }
        &.unicef-school {
          flex-basis: 100%;
          .school-tit {
            &::before {
              width: 16px;
              height: 19px;
            }
          }
        }
      }
    }
  }
`;
const SectionAfter = styled(Section)`
  padding-bottom: 30px !important;
  .card-flex {
    align-items: stretch;
    & > li {
      width: 33.33%;
      margin-bottom: 32px;
    }

    .card {
      height: 100%;
      padding: 24px;
      border-radius: 20px;
      border: solid 2px #1cabe2;
      .dec {
        strong {
          font-weight: 400;
          color: #1cabe2;
        }
      }
      dd {
        margin-top: 8px;
      }
    }
  }
  .tip {
    text-align: right;
    font-size: 14px;
    color: #828385;
    margin-top: -52px;
  }

  .quote-wrap {
    margin-top: 64px;
    background: #1cabe2;
    position: relative;
    margin-right: 30px;
    padding: 80px 20px;
    text-align: center;

    &:before {
      content: '';
      display: block;
      background: #b2def1;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 30px;
      top: 30px;
      z-index: -1;
    }

    ${Tit} {
      max-width: 754px;
      text-align: center;
      margin: 0 auto;
      display: inline-block;
      letter-spacing: -1.2px;

      &:before,
      &:after {
        content: '';
        display: block;
        width: 50px;
        height: 46px;
        background: url(${Quotes}) center no-repeat;
        background-size: cover;
        position: absolute;
      }
      &:before {
        left: 64px;
        top: 34px;
      }
      &:after {
        right: 54px;
        bottom: 53px;
        transform: rotate(180deg);
      }
    }
  }

  ${breakpoint(`tablet`)} {
    padding-bottom: 20px !important;
    .card-flex {
      & > li {
        width: 50%;
        margin-bottom: 20px;
      }
    }
    .tip {
      margin-top: 0;
    }

    .quote-wrap {
      margin-top: 48px;
      margin-right: 0;
      padding: 77px 20px;
      text-align: center;

      &:before {
        left: 20px;
        top: 20px;
      }

      ${Tit} {
        &:before,
        &:after {
          width: 32px;
          height: 29px;
        }
        &:before {
          left: 24px;
          top: 24px;
        }
        &:after {
          right: 24px;
          bottom: 24px;
        }
      }
    }
  }
  ${breakpoint(`mobile`)} {
    .card-flex {
      & > li {
        width: 100%;
      }
    }
    .tip {
      font-size: 12px;
    }
  }
`;
const SectionCurrent = styled(Section)`
  table {
    min-width: 500px;
    width: 100%;
    background: #fff;
    margin-top: 0;

    th {
      background: #edf7fa;
      border-bottom: 1px solid #ddd;
    }
    tbody {
      th,
      td {
        padding: 20px 0;
      }
    }
    ${breakpoint(`mobile`)} {
      colgroup {
        width: 100%;
        col {
          &:first-child {
            width: 21%;
          }
          &:nth-child(2) {
            width: 18%;
          }
          &:nth-child(3) {
            width: 34%;
          }
          &:last-child {
            width: 27%;
          }
        }
      }
    }
  }
`;
const SwiperCustom = styled(SwiperBasic)`
  padding: 0;
  .swiper-container {
    padding-bottom: 0px;
  }
  .swiper-slide {
    width: 100%;
    min-width: 500px;
  }
`;

const ChildFriendlySchools: React.FC<PageProps> = ({ location }) => {
  const [news, setNews] = useState<CampaignData[]>([]);

  const loadNews = useCallback(async () => {
    try {
      const { data } = await BoardCommonControllerService.foListUsingGet({
        boardCategoryCode: ['280', '285', '290'],
        pagePerCount: 8,
        category: ['A026'],
      });
      const articles = data as any;
      setNews(
        articles
          .map((article: BoardVo) => ({
            id: article.boardIndexNumber,
            title: article.subject,
            pcImage: article.imgAttGrpNoTn,
            mobileImage: article.imgAttGrpNoTn,
            link: `/what-we-do/news/${article.boardIndexNumber}`,
            date: article.firstRegisterDate,
            boardCategoryCode: article.boardCategoryCode,
          }))
          .sort((a, b) => new Date(b.date) - new Date(a.date) || b.id - a.id),
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    loadNews();
  }, [loadNews]);

  return (
    <LayoutWithTitle
      // 강제로 breadcrumb 고정
      location={{
        ...location,
        pathname: `/what-we-do/advocacy-for-children/public-private-partnership/child-friendly-cities`,
      }}
      paddingBtt
      title="아동친화사회 만들기"
      description="for every child, schools"
    >
      <PublicPrivateTab currentPath={location.pathname} />
      <Section className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1-5" color="sky" weight="bold">
                <PageComponent id="title1">
                  학교 구성원 모두가 <br className="pc-hide" /> 행복한 학교 만들기,
                  <br />
                  유니세프아동친화학교
                </PageComponent>
              </Tit>
            </h2>
            <p className="header-dec">
              <PageComponent id="content1">
                유니세프아동친화학교는 유엔아동권리협약을 기반으로 학교를
                운영하여, 아동권리 실현과 더불어 학교 구성원 모두의 권리를
                존중하는 학교 문화 만들기 프로그램입니다. 학생을 비롯한 학교
                구성원 모두가 아동권리를 이해하고 아동권리를 최우선으로 고려하여
                학교를 운영합니다. 이를 통해 학교 구성원 모두의 관계 속에서
                서로의 권리를 존중하는 법을 배우고, 아동권리를 존중하는 학교
                환경과 문화를 만들 수 있습니다. 학교 운영과 문화, 교풍 등 학교
                운영 전반에 유엔아동권리협약의 가치와 이념을 담아, 아동의 권리
                실현과 함께 학교 구성원 모두의 권리가 존중되는 학교 문화를
                만들어 갑니다. 이를 통해 학교 구성원 모두의 관계 속에서 권리
                존중 방법을 연습하고 태도를 익히며, 아동권리가 존중되는 학교
                환경을 실현할 수 있습니다.
              </PageComponent>
            </p>
          </SectionHeader>
          <PageComponent id="youtube1">
            <YoutubeSingle videoId="frTFYLuTSRU" />
          </PageComponent>
        </Container>
      </Section>

      <SectionSchool className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">
                유니세프아동친화학교의 <br />
                9가지 구성요소
              </Tit>
            </h2>
          </SectionHeader>
          <ObjList className="flex align-start">
            {schoolData.map((row, idnex) => (
              <li key={row.id}>
                <div className="img-wrap">
                  <Image pcSrc={row.img} mobileSrc={row.img} />
                </div>
                <div className="dec-wrap">
                  <strong className="no">{row.no}</strong>
                  <Tit
                    size="s4"
                    dangerouslySetInnerHTML={{ __html: row.tit }}
                  />
                </div>
              </li>
            ))}
          </ObjList>
        </Container>
      </SectionSchool>

      <SectionMembership
        className="by-sub-main-layout"
        backgroundColor="#F8FCFE"
      >
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">아동친화학교 멤버십에 어떻게 가입하나요?</Tit>
            </h2>
            <p className="header-dec">
              아동친화학교 9가지 구성요소를 갖추기 위한 활동을 계획하고
              이행하면서, <br className="m-hide" />
              아동들에게 나타나는 긍정적인 변화를 모니터링하며 학교 구성원 간
              상호존중하는 문화를 조성합니다.
            </p>
          </SectionHeader>

          <div className="section-body">
            <div className="box pre-school">
              <div className="school-tit">아동친화준비학교</div>
              <div className="school-stages">
                <div className="stage-list">
                  <div className="stage-tit">
                    아동친화학교 추진 조직구성 및
                    <br className="m-hide" /> 계획 수립
                  </div>
                  <p>(선택사항, 1학기 소요)</p>
                </div>
                <div className="stage-list">
                  <div className="stage-tit">계획시행</div>
                  <p>(필수, 2학기 소요)</p>
                </div>
              </div>
              <div className="school-desc">
                학교는 아동친화학교 구성요소를 바탕으로 학교의 권리 존중 현황을
                파악하고 아동친화학교를 조성하기 위한 계획을 수립합니다.
                <br className="m-hide" /> 아동친화학교 조성 계획을 이행하기 위한
                기반을 마련하고, 조성 계획을 실행합니다.
                <br className="m-hide" /> 이후 모든 학교 구성원이 아동권리에 대해
                이해하고 있고,
                <br className="m-hide" />
                유엔아동권리협약의 가치와 이념이 학교의 문화와 교풍, 정책에
                <br className="m-hide" />
                명시적으로 포함될 수 있도록 계획을 시행합니다.
                <br />
                아동친화학교 조성에 따라 학교 공동체의 학습, 관계 및 복지에
                <br className="m-hide" />
                긍정적 영향이 확인하는 지속적인 모니터링을 진행합니다.
              </div>
            </div>

            <div className="box unicef-school">
              <div className="school-tit">유니세프아동친화학교</div>
              <div className="school-stages">
                <div className="stage-list">
                  <div className="stage-tit">멤버십 운영</div>
                  <p>(1년간 유지)</p>
                </div>
              </div>
              <div className="school-desc">
                유니세프아동친화학교로서 보다 심화된
                <br className="m-hide" />
                아동친화학교 계획을 수립하고 실행하며,
                <br className="m-hide" />
                유엔아동권리협약의 가치와 이념을 학교 문화와 교풍,
                <br className="m-hide" />
                정책에 완전히 내재하여, 아동과 학교 구성원의 권리가
                <br className="m-hide" />
                존중되고 아동권리가 실현되는 교육환경을 갖춥니다.
                <br />
                학생들이 아동친화학교 조성 과정에 주도적 역할을 수행합니다.
                <br className="m-hide" /> 1년간 아동친화준비학교 운영을 마무리한
                이후에는 자동으로 멤버십 자격을 갖추게 되며, 1년 동안 자격이
                유지됩니다.
              </div>
            </div>
          </div>
        </Container>
      </SectionMembership>

      <SectionAfter className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">어떤 변화가 생기나요?</Tit>
            </h2>
            <p className="header-dec">
              유니세프아동친화학교를 조성한 학교의 학생들과 성인에 긍정적 변화가
              나타납니다.
            </p>
          </SectionHeader>
          <ul className="card-flex flex">
            <li>
              <dl className="card">
                <dt>
                  <Tit size="s4" color="sky">
                    권리인식 향상
                  </Tit>
                </dt>
                <dd>
                  <p className="dec">
                    학생 <strong>82%</strong>가 학교에서 아동권리를 배웁니다.
                  </p>
                </dd>
              </dl>
            </li>
            <li>
              <dl className="card">
                <dt>
                  <Tit size="s4" color="sky">
                    행복도 증가
                  </Tit>
                </dt>
                <dd>
                  <p className="dec">
                    학생 <strong>87%</strong>가 행복한 학교 생활을 합니다.
                  </p>
                </dd>
              </dl>
            </li>
            <li>
              <dl className="card">
                <dt>
                  <Tit size="s4" color="sky">
                    의견 & 참여 증가
                  </Tit>
                </dt>
                <dd>
                  <p className="dec">
                    학생 <strong>82%</strong>가 학교에서 자신의 의견이
                    존중된다고 느낍니다.
                  </p>
                </dd>
              </dl>
            </li>
            <li>
              <dl className="card">
                <dt>
                  <Tit size="s4" color="sky">
                    안전도 상승
                  </Tit>
                </dt>
                <dd>
                  <p className="dec">
                    학생 <strong>82%</strong>가 학교를 안전한 공간으로
                    인식합니다.
                  </p>
                </dd>
              </dl>
            </li>
            <li>
              <dl className="card">
                <dt>
                  <Tit size="s4" color="sky">
                    교사 근무 만족도 상승
                  </Tit>
                </dt>
                <dd>
                  <p className="dec">
                    교사 <strong>98%</strong>의 근무 만족도가 높아집니다.
                  </p>
                </dd>
              </dl>
            </li>
          </ul>
          <p className="tip">[출처] 유니세프영국위원회, 2018영향보고서</p>

          <div className="quote-wrap">
            <Tit size="s4" color="white">
              아동친화학교가 되는 여정은 학생과 교사 어느 한 쪽의 노력만으로
              계속될 수 없습니다. <br />
              학생과 교사, 그 외 학교에서 근무하는 모든 직원들, 학부모를 비롯한
              학생 보호자, 지역 사회 구성원 등 <br />
              아동을 둘러싼 모든 아동과 성인이 함께 노력하며 조성해야 합니다.
            </Tit>
          </div>
        </Container>
      </SectionAfter>

      <Section className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">어떻게 참여하나요?</Tit>
            </h2>
          </SectionHeader>
          <MultiAccordion
            initialKeys={[accordionData[0].id, accordionData[1].id]}
          >
            {accordionData.map((row) => (
              <MultiAccordionItem
                key={row.id}
                toggleKey={row.id}
                renderToggle={(onClick) => (
                  <NavigationButton
                    onClick={onClick}
                    className="accordion-opener"
                  >
                    <Tit size="s4">{row.label}</Tit>
                  </NavigationButton>
                )}
              >
                <AccordionBody>
                  <ul className="blit-list black">
                    {row.data.map((row2, index2) => (
                      <li key={index2}>
                        <p
                          className="dec"
                          dangerouslySetInnerHTML={{ __html: row2.dec }}
                        />
                        {row2.processor && (
                          <ProcessorList className="flex">
                            {row2.processor.map((row3, index3) => (
                              <li key={index3}>
                                <figure>
                                  <Image pcSrc={row3.img} mobileSrc={row3.img} />
                                </figure>
                                <strong className="dec">{row3.tit}</strong>
                              </li>
                            ))}
                          </ProcessorList>
                        )}
                      </li>
                    ))}
                  </ul>
                </AccordionBody>
              </MultiAccordionItem>
            ))}
          </MultiAccordion>
        </Container>
      </Section>

      <SectionCurrent className="by-sub-main-layout" backgroundColor="#F8FCFE">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">현황</Tit>
            </h2>
          </SectionHeader>

          <SwiperCustom>
            <Swiper
              slidesPerView="auto"
              scrollbar={{ draggable: true }}
              className="scroll-only"
            >
              <SwiperSlide key="1">
                <table>
                  <colgroup>
                    <col />
                    <col />
                    <col />
                    <col />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>협력 교육청</th>
                      <th>업무협약</th>
                      <th>유니세프아동친화학교</th>
                      <th>아동친화준비학교</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        충청북도
                        <br className="pc-hide" />
                        교육청
                      </td>
                      <td>
                        2019년 12월
                        <br className="pc-hide" /> ~ <br className="pc-hide" />
                        2023년 12월
                      </td>
                      <td>
                        청주 강서초등학교,
                        <br />
                        충주 달천초등학교,
                        <br />
                        음성 소이초등학교
                      </td>
                      <td>증평 죽리초등학교</td>
                    </tr>

                    <tr>
                      <td>
                        서울특별시
                        <br className="pc-hide" />
                        교육청
                      </td>
                      <td>
                        2021년 12월
                        <br className="pc-hide" /> ~ <br className="pc-hide" />
                        2024년 12월
                      </td>
                      <td>
                        서울반원초등학교,<br />
                        서울상천초등학교,<br />
                        서울신동초등학교,<br />
                        서울영중초등학교,<br />
                        서울조원초등학교,<br />
                        서울풍납초등학교,<br />
                        서울흥인초등학교
                      </td>
                      <td>
                        서울갈산초등학교,<br />
                        서울개운초등학교,<br />
                        서울거원초등학교,<br />
                        서울고일초등학교,<br />
                        서울대림초등학교,<br />
                        서울동답초등학교,<br />
                        서울등양초등학교,<br />
                        서울매헌초등학교,<br />
                        서울면남초등학교,<br />
                        서울묘곡초등학교,<br />
                        서울봉은초등학교,<br />
                        서울북가좌초등학교,<br />
                        서울상원초등학교,<br />
                        서울서교초등학교,<br />
                        서울성일초등학교,<br />
                        서울송파초등학교,<br />
                        서울수색초등학교,<br />
                        서울신용산초등학교,<br />
                        서울신자초등학교,<br />
                        서울아주초등학교,<br />
                        서울양원숲초등학교,<br />
                        서울양화초등학교,<br />
                        서울위례솔초등학교,<br />
                        서울잠일초등학교,<br />
                        서울중대초등학교,<br />
                        서울중마초등학교,<br />
                        서울천일초등학교,<br />
                        서울풍성초등학교,<br />
                        서울흥인초등학교
                      </td>
                    </tr>

                    <tr>
                      <td>
                        경상남도
                        <br className="pc-hide" />
                        교육청
                      </td>
                      <td>
                        2022년 12월
                        <br className="pc-hide" /> ~ <br className="pc-hide" />
                        현재
                      </td>
                      <td>
                        고성 대성초등학교,<br />
                        고성 거류초등학교,<br />
                        진주 반성초등학교,<br />
                        통영 제석초등학교,<br />
                        함안 대산초등학교,<br />
                        함안 아라초등학교,<br />
                        함안 외암초등학교,<br />
                        거제 해성중학교,<br />
                        고성 소가야중학교,<br />
                        진주 선인국제중학교,<br />
                        거제 거제고등학교,<br />
                         김해 율하고등학교,<br />
                        창녕 남지고등학교,<br />
                        창원 마산내서여자고등학교
                      </td>
                      <td>
                        진주 문산초등학교,<br />
                        창원 용호초등학교,<br />
                        합천 가야초등학교,<br />
                        남해 상주중학교,<br />
                        창녕 남지중학교
                      </td>
                    </tr>

                    <tr>
                      <td>
                        제주특별자치도
                        <br className="pc-hide" />
                        교육청
                      </td>
                      <td>
                        2023년 1월
                        <br className="pc-hide" /> ~ <br className="pc-hide" />
                        현재
                      </td>
                      <td>
                        제주 고산초등학교,<br />
                        제주 삼성초등학교,<br />
                        제주 함덕초등학교,<br />
                        제주 제일고등학교
                      </td>
                      <td>
                        제주 보목초등학교,<br />
                        제주 북촌초등학교,<br />
                        제주 신제주초등학교,<br />
                        제주 안덕초등학교,<br />
                        제주 오라초등학교,<br />
                        제주 인화초등학교,<br />
                        제주 종달초등학교,<br />
                        제주 재릉초등학교,<br />
                        제주 평대초등학교,<br />
                        제주 한림초등학교,<br />
                        제주 표선고등학교
                      </td>
                    </tr>

                    <tr>
                      <td>울산교육청</td>
                      <td>
                        2023년 7월
                        <br className="pc-hide" /> ~ <br className="pc-hide" />
                        현재
                      </td>
                      <td>
                        울산 강동초등학교,<br />
                        울산 다전초등학교,<br />
                        울산 외솔초등학교,<br />
                        울산 장검중학교,<br />
                        울산 혜인학교
                      </td>
                      <td>
                        울산 격동초등학교,<br />
                        울산 무거초등학교,<br />
                        울산 울주명지초등학교,<br />
                        울산 문현초등학교,<br />
                        울산 염포초등학교,<br />
                        울산 태화초등학교,<br />
                        울산 매곡초등학교,<br />
                        울산 삼호중학교,<br />
                        울산 강남고등학교,<br />
                        울산 범서고등학교
                      </td>
                    </tr>
                  </tbody>
                </table>
              </SwiperSlide>
            </Swiper>
          </SwiperCustom>
        </Container>
      </SectionCurrent>

      <SectionNews className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <div className="flex-middle">
              <h2>
                <Tit size="s1">최근 소식</Tit>
              </h2>
              <LinkSafe to="/what-we-do/news?category=A026" className="more">
                <span className="txt">더 보기</span>
              </LinkSafe>
            </div>
          </SectionHeader>
          {news.length > 0 && (
            <RelativeBoardCard
              newslist={news}
              isDate={false}
              isSwiper
              overflowHidden
            />
          )}
        </Container>
      </SectionNews>

      <Section
        className="by-sub-main-layout"
        css={`
          padding: 0 0 240px !important;
          ${breakpoint(`tablet`)} {
            padding: 60px 0 120px !important;
          }
        `}
      >
        <Container>
          <ContactUs itemData={contactData} />
        </Container>
      </Section>
    </LayoutWithTitle>
  );
};
export default ChildFriendlySchools;
